import store from './store';
import { mapGetters, mapActions } from 'vuex';

export default {
  created() {
    store.install(this.$store);
  },
  mounted() {
    if (!this.AdminList.length) {
      this.fetchAdminList();
    }
  },
  computed: {
    ...mapGetters('admins', ['AdminList']),
  },
  methods: {
    ...mapActions('admins', ['fetchAdminList']),
  },
};
